import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './bursa-api-stb-cert.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const BursaAPIStbCertDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const bursaAPIStbCertEntity = useAppSelector(state => state.bursaAPIStbCert.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bursaAPIStbCertDetailsHeading">
          <Translate contentKey="comexApp.bursaAPIStbCert.detail.title">BursaAPIStbCert</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.id}</dd>
          <dt>
            <span id="endpointURL">
              <Translate contentKey="comexApp.bursaAPIStbCert.endpointURL">Endpoint URL</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.endpointURL}</dd>
          <dt>
            <span id="ecertNo">
              <Translate contentKey="comexApp.bursaAPIStbCert.ecertNo">Ecert No</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.ecertNo}</dd>
          <dt>
            <span id="memberShortName">
              <Translate contentKey="comexApp.bursaAPIStbCert.memberShortName">Member Short Name</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.memberShortName}</dd>
          <dt>
            <span id="sucessYN">
              <Translate contentKey="comexApp.bursaAPIStbCert.sucessYN">Sucess YN</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.sucessYN}</dd>
          <dt>
            <span id="msg">
              <Translate contentKey="comexApp.bursaAPIStbCert.msg">Msg</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.msg}</dd>
          <dt>
            <span id="seller">
              <Translate contentKey="comexApp.bursaAPIStbCert.seller">Seller</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.seller}</dd>
          <dt>
            <span id="buyer">
              <Translate contentKey="comexApp.bursaAPIStbCert.buyer">Buyer</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.buyer}</dd>
          <dt>
            <span id="totalValue">
              <Translate contentKey="comexApp.bursaAPIStbCert.totalValue">Total Value</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.totalValue}</dd>
          <dt>
            <span id="currency">
              <Translate contentKey="comexApp.bursaAPIStbCert.currency">Currency</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.currency}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="comexApp.bursaAPIStbCert.price">Price</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.price}</dd>
          <dt>
            <span id="priceMYR">
              <Translate contentKey="comexApp.bursaAPIStbCert.priceMYR">Price MYR</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.priceMYR}</dd>
          <dt>
            <span id="sellingTimeDate">
              <Translate contentKey="comexApp.bursaAPIStbCert.sellingTimeDate">Selling Time Date</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.sellingTimeDate}</dd>
          <dt>
            <span id="valueDate">
              <Translate contentKey="comexApp.bursaAPIStbCert.valueDate">Value Date</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.valueDate}</dd>
          <dt>
            <span id="pName">
              <Translate contentKey="comexApp.bursaAPIStbCert.pName">P Name</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.pName}</dd>
          <dt>
            <span id="pVolume">
              <Translate contentKey="comexApp.bursaAPIStbCert.pVolume">P Volume</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.pVolume}</dd>
          <dt>
            <span id="supplier">
              <Translate contentKey="comexApp.bursaAPIStbCert.supplier">Supplier</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.supplier}</dd>
          <dt>
            <span id="volume">
              <Translate contentKey="comexApp.bursaAPIStbCert.volume">Volume</Translate>
            </span>
          </dt>
          <dd>{bursaAPIStbCertEntity.volume}</dd>
        </dl>
        <Button tag={Link} to="/bursa-api-stb-cert" replace data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/bursa-api-stb-cert/${bursaAPIStbCertEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BursaAPIStbCertDetail;
